import mainTemplate from '../../../modules/documents/views/main/main.tpl.html';
import listTemplate from '../../../modules/documents/views/main/list.tpl.html';
import detailsTemplate from '../../../modules/documents/views/main/details.tpl.html';
import DocumentsListController from '../../../modules/documents/controllers/main/list-controller';
import DocumentDetailsController from '../../../modules/documents/controllers/main/details-controller';

angular
    .module('festzelt-os.documents.main')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.documents.main', {
            abstract: true,
            templateUrl: mainTemplate,
            params: {
                back: 'app.documents.main.index',
                backParams: ['$stateParams', ($stateParams) => {
                    return {
                        store: $stateParams.store,
                    }
                }],
            },
            data: {
                showBackBtn: true,
                pageTitle: 'Documents'
            }
        })
        .state('app.documents.main.index', {
            url: '',
            sticky: true,
            data: {
                showBackBtn: false,
                rights: 'documents::list',
                view: 'index'
            },
            views: {
                index: {
                    templateUrl: listTemplate,
                    controller: DocumentsListController,
                    controllerAs: 'vm'
                }
            }
        })
        .state('app.documents.main.details', {
            url: '{id}',
            params: {
                store: undefined,
                backParams: ['$stateParams', ($stateParams) => {
                    return {
                        id: $stateParams.id,
                        store: $stateParams.store,
                    }
                }],
            },
            sticky: true,
            data: {
                rights: 'documents::view',
                view: 'details'
            },
            views: {
                details: {
                    templateUrl: detailsTemplate,
                    controller: DocumentDetailsController,
                    controllerAs: 'vm'
                }
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/pages/documents/main/routes.js